<template>
  <section class="w-full">
    <h1 class="flex items-center justify-between">
      {{ $t('components.company.phoneVerification.title') }}
    </h1>

    <div class="flex flex-wrap w-full">
      <div
        class="flex flex-wrap w-full"
      >
        <input-switch
          v-model="isPhoneVerificationEnabled"
          class="mb-6"
          :label="$t('components.company.phoneVerification.label')"
          @onChange="handleChange"
        />
      </div>
      <div>
        <p>
          {{ $t('components.company.phoneVerification.description') }}
          <br><br>

          <b>{{ $t('components.company.phoneVerification.warningAttention') }}</b> {{ $t('components.company.phoneVerification.warningText') }} <br>
          <b>{{ $t('components.company.phoneVerification.decisionLabel') }}</b> {{ $t('components.company.phoneVerification.decisionText') }} <br><br>

          {{ $t('components.company.phoneVerification.activationNote') }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import InputSwitch from '@/components/form/switch.vue'
import UPDATE_PHONE_VERIFICATION from '@/graphql/UpdatePhoneVerification.gql'

export default {
  components: { InputSwitch },
  props: {
    settings: { type: Object, default: () => {} },
    companyId: { type: String, default: '' },
    refetchSettings: { type: Function, default: () => {} }
  },
  data: function () {
    return {
      isPhoneVerificationEnabled: this.settings.settings.enabledPhoneVerification.VALUATION
    }
  },
  watch: {
    settings: {
      handler (newValue, oldValue) {
        this.isPhoneVerificationEnabled = newValue.settings.enabledPhoneVerification.VALUATION
      },
      deep: true
    }
  },
  methods: {
    async handleChange (newValue) {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_PHONE_VERIFICATION,
          variables: {
            input: { enabled: newValue, companyId: this.companyId }
          }
        })
        this.refetchSettings()
      } catch (e) {

      }
    }
  }
}
</script>
